import ListingPage from '../../components/ListingPage';
import PushNotificationsCards from '../../components/PushNotifications/PushNotificationsCards';

const PushNotificationsPage = () => {
  return (
    <ListingPage
      createRestrictionKey="pushNotificationsCreate"
      entityType="pushNotification"
      useStats={true}
      filterBy="name"
      Cards={PushNotificationsCards}
    />
  );
};

export default PushNotificationsPage;
